// Real-user Core Web Vitals reporting. Pushes each metric onto GTM's
// dataLayer as GA4 event_name `web_vital` (homepage only) with the
// canonical `metric_name` / `metric_value` params so a single GA4 tag in
// GTM can forward it as-is.
import { onCLS, onINP, onLCP, onTTFB, onFCP, type Metric } from "web-vitals";

type DataLayerWindow = Window & { dataLayer?: Record<string, unknown>[] };

function report(metric: Metric) {
  if (typeof window === "undefined") return;
  const w = window as DataLayerWindow;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: "web_vital",
    metric_name: metric.name,
    metric_value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
    metric_rating: metric.rating,
    metric_id: metric.id,
    page_path: window.location.pathname,
  });
}

export function initWebVitals() {
  // Homepage only — that's where performance tuning is happening and where
  // the GA4 web_vital event is scoped for reporting.
  if (typeof window === "undefined" || window.location.pathname !== "/") return;
  onLCP(report);
  onCLS(report);
  onINP(report);
  onTTFB(report);
  onFCP(report);
}